import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { DirectoryString } from "@peculiar/asn1-x509";
import { id_pda } from "./object_identifiers";
export const id_pds_dateOfBirth = `${id_pda}.1`;
export const id_pds_placeOfBirth = `${id_pda}.2`;
let PlaceOfBirth = class PlaceOfBirth extends DirectoryString {
};
PlaceOfBirth = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], PlaceOfBirth);
export { PlaceOfBirth };
export const id_pda_gender = `${id_pda}.3`;
export var Gender;
(function (Gender) {
    Gender["M"] = "M";
    Gender["F"] = "F";
    Gender["m"] = "m";
    Gender["f"] = "f";
})(Gender || (Gender = {}));
export const id_pda_countryOfCitizenship = `${id_pda}.4`;
export const id_pda_countryOfResidence = `${id_pda}.5`;
